<div *ngFor="let permission of permissions" class="permission-each"
    [ngStyle]="{'margin-left.px': level + 35}">
    <div
        class="p-2 d-flex align-items-center justify-content-between permission-head">
        <div class="permission-arrow" *ngIf="permission.children?.length"
            (click)="toggleExpand(permission.id)" style="cursor: pointer;">
            <svg-icon src="assets/images/icon-caret-right.svg"
                *ngIf="!isExpanded(permission.id)" fill="var(--light)"
                class="permission-arrow-icon-right"></svg-icon>
            <svg-icon src="assets/images/icon-caret-down.svg"
                *ngIf="isExpanded(permission.id)" fill="var(--light)"
                class="permission-arrow-icon-down"></svg-icon>
        </div>

        <ng-container *ngIf="!readOnly">
            <app-radio [multiple]="true" [isChecked]="isSelected(permission.id)"
                [class.header]="isHeader(permission.id)"
                (onCheckChanged)="onTogglePermission(permission)">
                {{ permission.description }}
            </app-radio>
        </ng-container>

        <ng-container *ngIf="readOnly">
            {{ permission.description }}
        </ng-container>


        <div class="permission-container-body-list-each-number"
            *ngIf="permission.children?.length">
            {{ permission.children.length }}
        </div>
    </div>

    <div *ngIf="permission.children?.length && isExpanded(permission.id)">
        <app-permission-tree [permissions]="permission.children"
            [readOnly]="readOnly" [level]="level + 1"
            [selectedPermissions]="selectedPermissions"
            (permissionChange)="onPermissionToggle($event)">
        </app-permission-tree>
    </div>
</div>